'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEY = 'middleware/@geocoding/';

var GEOCODE_LOCATIONS_FULFILLED = exports.GEOCODE_LOCATIONS_FULFILLED = KEY + 'GEOCODE_LOCATIONS_FULFILLED';
var GEOCODE_LOCATION = exports.GEOCODE_LOCATION = KEY + 'GEOCODE_LOCATION';


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/geocoding/types.js
// module id = 145
// module chunks = 0